import React, { useMemo } from 'react';
import { get, isNull } from 'lodash';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { deviceToProductTypeDisplayString, toggleDisplayNameForDevices } from 'common/utils/helpers';
import { selectActiveDeviceDisplayMode } from 'redux/selectors';
import { EchoSolidIcon, PivotSolidIcon } from 'components/icons';
import { isGa2Device } from 'common/utils/deviceTwinUtils';
import DeviceStatusBox from './DeviceStatusBox';
import styles from './DeviceCard.module.css';

function DeviceCard({ device }) {
  const deviceDisplayMode = useSelector(selectActiveDeviceDisplayMode);
  const deviceId = device.deviceId ?? device.id ?? '';
  const deviceName = toggleDisplayNameForDevices(device, deviceDisplayMode);
  const deviceType = deviceToProductTypeDisplayString(device);
  const isGa2 = isGa2Device(device);
  const centerFreq = '28';
  const centerArfcn = isGa2 ? get(device, 'properties.reported.DU.center-arfcn', 'N/A') : null;
  const isPivot = ['Pivot 5G Donor', 'Pivot 5G Service', 'Pivot 5G'].includes(deviceType);

  const deviceIcon = useMemo(() => {
    if (isPivot || isGa2) {
      return <PivotSolidIcon className={styles.pivotIcon} />;
    } else if (deviceType === 'Echo 5G') {
      return <EchoSolidIcon className={styles.echoIcon} />;
    }
  }, [isPivot, isGa2, deviceType]);

  const linkUrl = isGa2
    ? `/console/devices/pivot/overview?deviceId=${deviceId}`
    : `/console/devices/detail?${deviceId}`;

  return (
    <div className={styles.root}>
      <div className={styles.row}>
        <div className={styles.cell}>
          <div className={styles.data} data-tip={deviceName}>
            {deviceIcon}
            <Link className={styles.link} to={linkUrl}>
              {deviceName}
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.data}>
          <DeviceStatusBox device={device} />
        </div>
        {!isGa2 && centerFreq && (
          <div className={styles.data}>
            <div className={styles.centerFreq}>{`${centerFreq} GHz`}</div>
          </div>
        )}
        {isGa2 && !isNull(centerArfcn) && (
          <div className={styles.data}>
          <div className={styles.centerArfcn}>{`ARFCN: ${centerArfcn}`}</div>
        </div>
        )}
      </div>
    </div>
  );
}

export default DeviceCard;
